var fontWeights = {
    display: {
        base: 600,
        heavy: 700,
    },
    heading: {
        slim: 500,
        base: 600,
        heavy: 700,
    },
    label: {
        base: 500,
        heavy: 600,
    },
    paragraph: {
        base: 400,
        heavy: 500,
    },
};

export { fontWeights as default };
//# sourceMappingURL=fontWeights.js.map
